import { render, staticRenderFns } from "./CheckoutStep2.vue?vue&type=template&id=b9151a7e&"
import script from "./CheckoutStep2.vue?vue&type=script&lang=ts&"
export * from "./CheckoutStep2.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutStep2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports